module.exports = __webpack_public_path__ + "static/img/guan.e4c94bf6.png";